import React, { useState } from 'react';
import styles from './ImageUpload.module.css';
import img from '../../../../assets/icons/upload-image.svg';
const ImageUpload = ({ label, onChange }) => {
  const [fileName, setFileName] = useState('Upload Image');
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB

    if (fileSizeMB > 2) {
      alert('File size should not exceed 2MB.');
      setFileName('Upload Image');
      e.target.value = '';
      return;
    }
    setFileName(file?.name);
    if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
      onChange(file);
    } else {
      alert('Please upload a valid JPG or PNG file.');
      setFileName('');
    }
  };

  return (
    <div className={styles.imageUploadContainer}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputContainer}>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className={styles.fileInput}
          id="fileInput"
        />
        <label htmlFor="fileInput" className={styles.inputLabel}>
          <img src={img} alt="Upload Icon" width={24} height={24} /> {fileName}
        </label>
      </div>
      <span>Accepted file types: .jpeg, .png (Max: 2MB)</span>
    </div>
  );
};

export default ImageUpload;
